export const { subscribe, showNotif, hide } = (function () {
  let handler = null;
  function subscribe(fn) {
    handler = fn;
    return () => {
      handler = null;
    };
  }

  function hide(id) {
    if (handler) {
      handler(notifs => notifs.filter(notif => notif.id !== id));
    }
  }

  function showNotif(message) {
    if (handler) {
      message.id = new Date().getTime();
      handler(notifs => notifs.concat(message));
      setTimeout(() => {
        hide(message.id);
      }, message.dismissAfter);
    }
  }

  return { subscribe, showNotif, hide };
})();
